// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"093652be","282":"7462d0d5","317":"920e9249","535":"c4e6866b","572":"4c0dc0fc","697":"4687ca0f","977":"fbac28d8"}[chunkId] + ".chunk.js";
};